// extracted by mini-css-extract-plugin
module.exports = {"cus-mtdicon":"if","cusMtdicon":"if"};